import { z } from "zod";

export const validationSchema = z.object({
  color: z.string().nonempty(),
  name: z.string().min(1),
  projectGroupId: z.string().uuid(),
});
